export const WarningWrapper = ({ children }: any) => (
  <div
    className="grid gap-2 rounded border border-l-8 border-yellow-500 p-5"
    data-testid="plan-cancelled"
  >
    {children}
  </div>
);
